<div [ngClass]="showMenu ? 'menu-opened' : 'menu-collapsed'" id="menu-overlay" class="menu-overlay">
  <div class="flex justify-start items-center gap-2 pt-8 pl-8">
    <mat-icon aria-hidden="true" class="md-20">person</mat-icon>
    <span class="w-60 dcp-body-bold uppercase text-nowrap-ellipsis">{{ userName }}</span>
    <pin-button buttonId="menu-close-button" buttonStyle="icon" customClass="menu-close-button" (buttonClick)="closeMenu()">
      <mat-icon>close</mat-icon>
    </pin-button>
  </div>

  <ng-content *ngTemplateOutlet="menuItemsTemplate">
  </ng-content>
</div>
